import { render, staticRenderFns } from "./BannerSubmitComponent.vue?vue&type=template&id=a7112554&scoped=true&functional=true&"
import script from "./BannerSubmitComponent.vue?vue&type=script&lang=js&"
export * from "./BannerSubmitComponent.vue?vue&type=script&lang=js&"
import style0 from "./BannerSubmitComponent.vue?vue&type=style&index=0&id=a7112554&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "a7112554",
  null
  
)

export default component.exports